import React, { useMemo } from 'react';
import { Box } from '@usap/uicomponents';
import { TextWithPointer } from '../StyledCSS';
import Label from './Label';

export default function UniversalFitContainer({
  selectedVehicle,
  vehicleString,
  cart,
  checkout,
  productOption,
  addVehicleTrigger,
  orderItemId,
  addVehicleTriggerSecondParam,
  firstLabelText,
  dataTestPrefix = '',
}) {
  const dataTestId = useMemo(() => {
    if (selectedVehicle && selectedVehicle.year) {
      if (firstLabelText?.toLowerCase()?.includes('universal')) {
        return `${dataTestPrefix}universal-fit-change-vehicle-pdp`
      }

      return `${dataTestPrefix}guaranteed-to-fit-change-vehicle-pdp`
    }

    return ''
  }, [selectedVehicle, firstLabelText, dataTestPrefix])

  return (
    <Box pad={{ left: 'small' }} align="start" justify="center" width="100%">
      <Label>{firstLabelText}</Label>

      {selectedVehicle && (
        <Label size="small" style={{ width: '100%' }}>
          {vehicleString}
        </Label>
      )}
      {!cart && !checkout && !productOption && (
        <TextWithPointer
          color="blueLink"
          onClick={() =>
            addVehicleTrigger(orderItemId, addVehicleTriggerSecondParam)
          }
          style={{
            marginTop: '8px',
            textDecoration: 'underline'
          }}
          fxSize={{ large: '14px', other: '12px' }}
          weight="bold"
          data-testid={dataTestId}
        >
          {selectedVehicle && selectedVehicle.year
            ? 'Change Vehicle'
            : 'Add Vehicle'}
        </TextWithPointer>
      )}
    </Box>
  );
}
